import React from 'react';
import DashHeader from '../components/DashHeader';
import DashSide from '../components/DashSide';
import Table from '../components/Table';

const Holy = () => {
  return (
    <div className="w-screen h-screen bg-gray-100 flex">
      <div className="fixed top-0 left-0 w-full">
        <DashHeader />
      </div>
      <div className="fixed top-16 left-0 h-screen">
        <DashSide />
      </div>
      <div className="ml-[256px] mt-[80px] overflow-auto flex-grow">
        <Table />
      </div>
    </div>
  );
};

export default Holy;